const initialState = {
  wishList: [],
  wishListSkuIds: [],
};

const actions = {
  SET_WISH_LIST: 'wishlist/SET_WISH_LIST',
  SET_WISH_LIST_SKU_IDS: 'wishlist/SET_WISH_LIST_SKU_IDS',
};

export const MyShoppingListReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
  if (action.type === actions.SET_WISH_LIST) {
    return {
      ...state,
      wishList: action.payload,
    };
  } else if (action.type === actions.SET_WISH_LIST_SKU_IDS) {
    return {
      ...state,
      wishListSkuIds: action.payload,
    };
  } else {
    return state;
  }
};

export const setWishListData = (items) => ({
  type: actions.SET_WISH_LIST,
  payload: items,
});
export const setWishListSkuIds = (ids) => ({
  type: actions.SET_WISH_LIST_SKU_IDS,
  payload: ids,
});

export default MyShoppingListReducer;

